import { createAction } from "redux-actions";
import { FeedbackConstants } from "../constants/feedback.constants";

export const openFeedbackDialog = createAction(
    FeedbackConstants.OPEN_FEEDBACK_DIALOG
);
export const closeFeedbackDialog = createAction(
    FeedbackConstants.CLOSE_FEEDBACK_DIALOG
);
export const submitFeedback = createAction(FeedbackConstants.SUBMIT_FEEDBACK);
export const submitFeedbackSuccess = createAction(
    FeedbackConstants.SUBMIT_FEEDBACK_SUCCESS
);
export const submitFeedbackFailure = createAction(
    FeedbackConstants.SUBMIT_FEEDBACK_FAILURE
);



// WEBPACK FOOTER //
// ./src/actions/feedback.actions.js